import { render, staticRenderFns } from "./CursoVersionListFilters.vue?vue&type=template&id=218585ec&"
import script from "./CursoVersionListFilters.vue?vue&type=script&lang=js&"
export * from "./CursoVersionListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CursoVersionListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports